export * from './deletionHistory.service';
import { DeletionHistoryService } from './deletionHistory.service';
export * from './patient.service';
import { PatientService } from './patient.service';
export const APIS = [DeletionHistoryService, PatientService];
